export default "__VITE_ASSET__DANoAB5Y__"